import {
  MutationStatus,
  UseMutateAsyncFunction,
  useMutation
} from 'react-query';

import { getAPIErrorMessage } from '@nw/shared/utils';

import {
  GetTemplateResponseRequestObjectType,
  GetTemplateResponseResponseType
} from '../../../services/NwApplicationServices/APIService/types';

import { useNwApplicationService } from '../useNwApplicationService';

interface UseGetTemplateResponseInterface {
  getTemplateResponseApi: UseMutateAsyncFunction<
    GetTemplateResponseResponseType,
    unknown,
    GetTemplateResponseRequestObjectType,
    unknown
  >;
  error: string;
  status: MutationStatus;
}

const useGetTemplateResponse = (): UseGetTemplateResponseInterface => {
  const { nwApplicationService } = useNwApplicationService();

  const getTemplateResponse = (
    requestObject: GetTemplateResponseRequestObjectType
  ) => {
    return nwApplicationService.getTemplateResponse(requestObject);
  };

  const { mutateAsync, error, status } = useMutation(getTemplateResponse, {
    mutationKey: ['getTemplateResponseApi']
  });

  return {
    getTemplateResponseApi: mutateAsync,
    error: error ? getAPIErrorMessage(error) : '',
    status
  };
};

export { useGetTemplateResponse };
